import { useEffect, useRef, useState } from "react";
import { MdEdit } from "react-icons/md";
import { BiSolidRightArrow } from "react-icons/bi";
import CharacteristicsModule from './../components/CharacteristicsModule'
import GroupingCharacteristicsModule from './../components/GroupingCharacteristicsModule'
import LibrariesModule from './../components/LibrariesModule'
import "./App.css";

function CatalogPage() {
  //const [selectedParamcode, setSelectedParamcode] = useState(null);
  const [data, setData] = useState([]);
  const [openInfo, setOpenInfo] = useState(false);

  //const [info, setInfo] = useState([]);

  const [items, setItems] = useState([]);
  const [itemsTypes, setItemsTypes] = useState([]);

  const [openCatalog, setOpenCatalog] = useState(false);

  const [catalog, setCatalog] = useState([]);

  const [seletectedTypecode, setSelectedTypecode] = useState(null);

  /*const [openCatalogDetail, setOpenCatalogDetail] = useState(false);

  const [catalogDetail, setCatalogDetail] = useState([]);*/

  const [openGroup, setOpenGroup] = useState(false);

  const [withCheckboxes, setWithCheckboxes] = useState(false);
  const [showSecondTree, setShowSecondTree] = useState(false); // Контролируем отображение второго дерева

  /*const [group__info, setGroup__Info] = useState(false);
  const [libs__params, setLibs__Params] = useState(false);*/
  const [paramsCat, setParamsCat] = useState([]);

  //const [openAddModal, setOpenAddModal] = useState(false);
  /*const [inputValue, setInputValue] = useState("");
  const [typedata, setTypedata] = useState({});*/

  const modalRef = useRef(null);
  const modalRefHeader = useRef(null);
  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const allUsers = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/objects_list/selectObjectTypes`
    );
    const result = await allUsers.json();
    setData(result);
  }
  // Handle USer role update
  const handeleOpenInfo = (item) => {
    setShowSecondTree(true);
    setWithCheckboxes(true);
    setOpenInfo(true);
    setSelectedTypecode(item.id);
    getInfoTools(item.id);
    //setTypedata(item);
  };

  const handeleWrapClick = (event) => {
    console.log("close " + modalRefHeader.current.contains(event.target) );
    if ((modalRef.current && !modalRef.current.contains(event.target) && modalRefHeader.current && !modalRefHeader.current.contains(event.target)) || (event.target.id === 'closeWrap')) {
      console.log(items);
      setOpenInfo(false);
      setOpenCatalog(false);
      //setCatalog([]);
      //setInfo([]);
     // setCatalogDetail([]);
     // setOpenCatalogDetail(false);
      //setGroup__Info([]);
      setOpenGroup(false);
     // setLibs__Params([]);
    //  setInputValue("");
    //  setTypedata({});
     // setOpenAddModal(false);
     // setSelectedParamcode();
    }
  };

  const getInfoTools = async (typecode) => {
    /*const allUsers = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/object_params/selectParamsFromLibraryByTypecode?typecode=${typecode}`
    );
    const result = await allUsers.json();
    setInfo(result);*/
    fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/selectParamsFromLibraryByTypecode?typecode=${typecode}`)
      .then(response => response.json())
      .then(data => {
       // setInfo(response);
        setItemsTypes(data);
       // console.log(data[0].paramcode);
        //setLoading(false);
      })
      .catch(error => {
        console.error('Ошибка при загрузке данных:', error);
        //setLoading(false);
      });

      const allParams = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/object_params/selectParamsFromLibrary`
      );
      const result = await allParams.json();
      setItems(result);
  };

  const addItem = (id, name, parent, paramtype, isFolder, libcode) => {
    const newItem = {
      id: id,
      name: name,
      parent: parent,
      paramtype: paramtype,
      isFolder: isFolder,
      libcode: libcode
    };
    setItems([...items, newItem]);
  };

  const addItemInType = (id, name, parent, paramcode, typecode, paramtype, libcode) => {
    const newItem = {
      id: id,
      name: name,
      parent: parent,
      paramcode: paramcode,
      typecode: typecode,
      paramtype: paramtype,
      libcode: libcode
    };
    setItemsTypes([...itemsTypes, newItem]);
  };

  const addCatItem = (id, name, parent) => {
    const newItem = {
      id: id,
      name: name,
      parent: parent
    };
    setParamsCat([...paramsCat, newItem]);
  };

  const deleteItemFromType = (id) => {
    const deleteItemRecursively = (id, items) => {
      return items.filter(item => item.id !== id && item.parent !== id);
    };
    setItemsTypes(deleteItemRecursively(id, itemsTypes));
  };

  const deleteItem = (id) => {
    const deleteItemRecursively = (id, items) => {
      return items.filter(item => item.id !== id && item.parent !== id);
    };
    setItems(deleteItemRecursively(id, items));
  };

  const deleteCatItem = (id) => {
    const deleteItemRecursively = (id, items) => {
      return items.filter(item => item.id !== id && item.parent !== id);
    };
    setParamsCat(deleteItemRecursively(id, paramsCat));
  };

  /*const updateItemName = (id, newName) => {
    setItems(items.map(item =>
      item.id === id
        ? { ...item, name: newName }
        : item
    ));
  };*/

  const updateItemCatName = (id, newName) => {
    setParamsCat(paramsCat.map(item =>
      item.id === id
        ? { ...item, name: newName }
        : item
    ));
  };

  /*const updateItemParamName = (id, newName) => {
    setItems(items.map(item =>
      item.id === id
        ? { ...item, name: newName }
        : item
    ));
  };*/

  const updateItemParamName = (id, updatedFields) => {
    setItems(items.map(item =>
      item.id === id
        ? { ...item, ...updatedFields } // обновляем сразу несколько полей
        : item
    ));
  };

  const updateItemType = (id, newStandardValue) => {
    setItemsTypes(itemsTypes.map(item =>
      item.id === id
        ? { ...item, standardvalue: newStandardValue }
        : item
    ));
  };

  /*const changeLibCode = (event, item) => {
    const sendData = {
      standardvalue: event.target.checked ? 1 : 0,
      typecode: item.paramtype,
      paramcode: item.paramcode,
    };
    const saveUserApi = `${process.env.REACT_APP_BASE_URL}/object_params/insertToLibObjParams `;
    fetch(saveUserApi, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(sendData),
    })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.error("Ошибка обновления позиции ", error);
      });
  };*/
  const getParamtype = (paramtype) => {
    if (paramtype === 0) {
      return "строка";
    }
    if (paramtype === 1) {
      return "целое число";
    }
    if (paramtype === 2) {
      return "дробное число";
    }
    if (paramtype === 3) {
      return "дата";
    }
    return "значение из справочника";
  };
  const allParamsModal = async (modal) => {
    const allParams = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/object_params/selectParamsFromLibrary`
    );
    const result = await allParams.json();
    setShowSecondTree(false);
    setWithCheckboxes(false);
    setOpenInfo(true);
    setItems(result);
    /*fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/selectParamsFromLibraryByTypecode?typecode=${typecode}`)
    .then(response => response.json())
    .then(data => {
     // setInfo(response);
      setItems(data);
     // console.log(data[0].paramcode);
      //setLoading(false);
    })
    .catch(error => {
      console.error('Ошибка при загрузке данных:', error);
      //setLoading(false);
    });*/

    //setCatalog(result);
    //setOpenCatalog(true);
  };
  const catalogModal = async (modal) => {
    const allUsers = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/object_params/selectAttachedLib`
    );
    const result = await allUsers.json();
    setCatalog(result);
    setOpenCatalog(true);
  };
  /*const openCatalogDetails = async (item) => {
    setSelectedParamcode(item.libcode);
    const allUsers = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/object_params/selectParamsLib?libcode=${item.libcode}`
    );
    const result = await allUsers.json();
    setCatalogDetail(result);
    setOpenCatalogDetail(true);
  };*/

  const groupModal = async (modal) => {
    console.log("grouping");
    setOpenGroup(true);
    const allParams = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/object_params/selectLibParamsCat`
    );
    const result = await allParams.json();
    setParamsCat(result);
  };
  /*const getGorupInfo = async (item) => {
    setGroup__Info(true);
    getInfoTools(item.typecode);
    setLibs__Params(true);
    const allParams = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/object_params/selectLibParamsCat`
    );
    const result = await allParams.json();
    setParamsCat(result);
  };

  const add__tool_new = () => {
    console.log("add__tool_new");
    setOpenAddModal(true);
  };

  const add__new = () => {
    const sendData = {
      name: inputValue,
      parent: typedata.typecode,
      paramtype: 0,
      isFolder: 0,
      reportName: inputValue,
      isshown: 1,
    };
    const saveUserApi = `${process.env.REACT_APP_BASE_URL}/api/object_params/insertToLibObjParams `;
    fetch(saveUserApi, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(sendData),
    })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.error("Ошибка обновления позиции ", error);
      });
  };*/
  return (
    <>
      <div className="admin_page">
        <div className="click__header">
          <span className="add__buttons" onClick={groupModal}>
            {" "}
            Группировка характеристик
          </span>
          <span className="add__buttons" onClick={catalogModal}>
            Справочники
          </span>
          <span className="add__buttons" onClick={allParamsModal}>
            Характеристики
          </span>
        </div>
        <table>
          <thead>
            <tr>
              <th>Тип обордования</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr className="catolog__row" key={index}>
                <td className="catolog__name">{item.name}</td>
                <td
                  className="catolog__edit"
                  onClick={() => handeleOpenInfo(item)}
                >
                  <MdEdit />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {openInfo && (
      <CharacteristicsModule handeleWrapClick={handeleWrapClick} modalRef={modalRef} modalRefHeader={modalRefHeader} showSecondTree={showSecondTree} withCheckboxes={withCheckboxes} 
        items={items} itemsTypes={itemsTypes} addItem={addItem} deleteItem={deleteItem} updateItem={updateItemParamName} addItemInType={addItemInType} deleteItemFromType={deleteItemFromType}
        selectedTypecode={seletectedTypecode} updateItemType={updateItemType}/>
)}
      {openCatalog && (
        <LibrariesModule handeleWrapClick={handeleWrapClick} modalRef={modalRef} modalRefHeader={modalRefHeader} />
        /*<div className="catalog__wrap" onClick={handeleWrapClick}>
          <div ref={modalRef} className="tool__list">
            <div className="list__catalog">
              {" "}
              {catalog.map((item, index) => (
                <div
                  key={item.id}
                  className={`tool__name ${
                    item.libcode === selectedParamcode ? "selected" : ""
                  }`}
                  onClick={() => openCatalogDetails(item)}
                >
                  {item.libname}
                </div>
              ))}
            </div>
            <div className="details__wrap">
              {openCatalogDetail && (
                <div className="">
                  {catalogDetail.map((item, index) => (
                    <div key={item.id} className="tool__name">
                      {item.libcode} | {item.plcode} | {item.plname}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>*/
      )}
      {openGroup && (
        <GroupingCharacteristicsModule handeleWrapClick={handeleWrapClick} modalRef={modalRef} modalRefHeader={modalRefHeader} items={data} catsItems={paramsCat} 
        addCatItem={addCatItem} deleteCatItem={deleteCatItem} updateItemCatName={updateItemCatName} />
    )}
            {/*openGroup && (
        <div className="tools__wrap" onClick={handeleWrapClick}>
          <div ref={modalRef} className="tool__list group__wrap">
            <div className="group__data">
              {" "}
              {data.map((item, index) => (
                <div
                  key={item.paramcode}
                  className="tool__name"
                  onClick={() => getGorupInfo(item)}
                >
                  {item.typename}
                </div>
              ))}
            </div>
            {group__info && (
              <div className="group__info">
                {info.map((item, index) => (
                  <div key={item.paramcode} className="tool__name">
                    {item.isFolder === 1 && (
                      <span>
                        <BiSolidRightArrow />
                      </span>
                    )}
                    <input
                      onChange={(event) => changeLibCode(event, item)}
                      type="checkbox"
                      className="tool__checkbox"
                      value={item.libcode}
                    />
                    {item.name}
                    <span className="tool__paramtype">
                      {getParamtype(item.paramtype)}
                    </span>
                  </div>
                ))}
                 
              </div>
            )}
            {libs__params && (
              <div className="group__info">
                {params.map((item, index) => (
                  <div key={item.id} className="tool__name">
                    {item.catname}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )*/}
    </>
  );
}

export { CatalogPage };
